;(function () {
    function initQvModal() {
        let quickViewButtons = document.querySelectorAll('[data-quickview]')
        let quickViewModal = document.querySelector('#quickViewModal')

        if (!quickViewModal) {
            return
        }

        let allQVItems = quickViewModal.querySelectorAll('[data-qv]')

        const microModalSettings = {
            openClass: 'is-open',
            onShow: () => {
                document.body.classList.add('modal-open')
            },
            onClose: () => {
                document.body.classList.remove('modal-open')
            },
        }

        /**
         *
         * Clicking Quick view buttons on product tiles triggers an ajax request
         * It gets that product's json page and sends the json objwect to the _populateQVModal function
         *
         */
        quickViewButtons.forEach((el) => {
            el.addEventListener('click', function (e) {
                e.preventDefault()

                _emptyQVModal()

                MicroModal.show('quickViewModal', microModalSettings)

                let thisProductURL = el.dataset.quickview
                let thisProductMeta = el.dataset.metainfo
                let pageData

                fetch(thisProductURL)
                    .then((response) => response.json())
                    .then((pageContents) => {
                        fetch(thisProductMeta)
                            .then((response) => response.json())
                            .then((pageMeta) => {
                                // Combine all the information to 1 object
                                pageData = Object.assign(pageContents, pageMeta)

                                window.currentQVItem = pageData
                                _populateQVModal(pageData)
                            })
                            .catch((error) => {
                                console.error(
                                    'Error fetching page meta:',
                                    error
                                )
                            })
                    })
                    .catch((error) => {
                        console.error('Error fetching page content:', error)
                    })
            })
        })

        /**
         *
         * This function takes the product json from above and injects it in to the modal
         * Every time it runs it just replaces the same modal (so theres NOT 1 modal per product)
         * It attempts to replicate the liquid logic from product-hero.liquid
         *
         */
        function _populateQVModal(data) {
            let outputHTML = ''

            // populate window variable for Klaviyo
            window.qvItem = {
                Brand: data.vendor,
                Categories: data.type,
                ImageURL: data.featured_image,
                Name: data.title,
                Price: Shopify.formatMoney(data.price),
                CompareAtPrice: Shopify.formatMoney(data.compare_at_price),
                ProductID: data.id,
                URL: window.location.origin + data.url,
            }

            allQVItems.forEach(function (el) {
                outputHTML = ''

                let currentVariant = data.variantStock[data.variants[0].id]

                switch (el.dataset.qv) {
                    case 'title':
                        el.innerHTML = data.title
                        break

                    case 'description':
                        el.innerHTML = data.description
                        break

                    case 'price':
                        el.innerHTML = Shopify.formatMoney(
                            data.price,
                            window.money_format
                        )
                        break

                    case 'handle':
                        el.innerHTML =
                            '<input type="hidden" name="handle" value="' +
                            data.handle +
                            '"/>'
                        break

                    case 'compare':
                        if (data.compare_at_price > data.price) {
                            el.innerHTML = Shopify.formatMoney(
                                data.compare_at_price,
                                window.money_format
                            )
                        }
                        break

                    case 'subscriptions':
                        if (
                            data.selling_plan_groups &&
                            data.selling_plan_groups.length > 0
                        ) {
                            data.selling_plan_groups.forEach((group, index) => {
                                outputHTML +=
                                    '<div class="subscriptions__group">'
                                outputHTML +=
                                    '<p class="h4">' + group.name + '</p>'

                                group.selling_plans.forEach(
                                    (selling_plan, sp_index) => {
                                        outputHTML +=
                                            '<label for="plan-qv-' +
                                            index +
                                            '-' +
                                            sp_index +
                                            '">'
                                        outputHTML +=
                                            '<input type="radio" id="plan-qv-' +
                                            index +
                                            '-' +
                                            sp_index +
                                            '" name="selling_plan" value="' +
                                            selling_plan.id +
                                            '" ' +
                                            (index == 1 ? 'checked' : '') +
                                            '/>'
                                        outputHTML += selling_plan.name
                                        outputHTML += '</label>'
                                    }
                                )

                                outputHTML += '</div>'
                            })

                            el.innerHTML = outputHTML
                        }
                        break

                    case 'variants':
                        if (data.available && data.variants.length > 1) {
                            outputHTML +=
                                '<select id="product-selectors-qv" name="id">'

                            for (let i = 0; i < data.variants.length; i++) {
                                if (data.variants[i].available) {
                                    outputHTML +=
                                        '<option  value="' +
                                        data.variants[i].id +
                                        '">'
                                    outputHTML += data.variants[i].title
                                    outputHTML += '</option>'
                                } else {
                                    outputHTML +=
                                        '<option disabled>' +
                                        data.variants[i].title +
                                        ' - ' +
                                        inventory_text.sold_out +
                                        '</option>'
                                }
                            }

                            outputHTML += '</select>'
                        } else {
                            outputHTML +=
                                '<input name="id" value="' +
                                data.variants[0].id +
                                '" type="hidden" />'
                        }

                        el.innerHTML = outputHTML

                        // convert options from object to string, else the below optionselector fails
                        for (let j = 0; j < data.options.length; j++) {
                            data.options[j] = data.options[j].name
                        }
                        break

                    case 'quantity':
                        if (data.available) {
                            let min_buy = 1
                            let max_buy = 999999
                            if (data.metafields != false) {
                                min_buy = data.metafields.min_buy
                                max_buy = data.metafields.max_buy
                            }
                            outputHTML += '<div class="product-quantity">'

                            outputHTML += `<label for="Quantity-qv" class="sr-only">Qty</label>
										<div class="d-flex qty-container">
											<span class="qty-btn decrease js-qty-update quickview-qty">-</span>
											<input type="number" id="Quantity-qv" name="quantity" data-qtt-id value="1" min="${min_buy}" max="${max_buy}" >
											<span class="qty-btn increase js-qty-update quickview-qty">+</span>
										</div>`

                            let stock_text = ''
                            let stock_class = ''

                            if (currentVariant.inventory >= 5) {
                                stock_text = inventory_text.in_stock_long
                                stock_class = 'instock'
                            } else if (currentVariant.inventory > 0) {
                                stock_text = inventory_text.low_stock_long
                                stock_class = 'lowstock'
                            } else if (
                                currentVariant.inventory_management != 'null'
                            ) {
                                stock_text = inventory_text.sold_out_long
                                stock_class = 'outofstock'
                            } else if (
                                currentVariant.inventory_management == 'null'
                            ) {
                                stock_text = ''
                                stock_class = ''
                            }

                            if (stock_text != '' && stock_class != '') {
                                outputHTML += `<span class="stock-indicator ${stock_class}">
											${stock_text}		
										</span>`
                            }

                            outputHTML += '</div>'
                        }

                        el.innerHTML = outputHTML

                        break

                    case 'availability':
                        if (data.available) {
                            let invalid = ''

                            if (
                                currentVariant.inventory_policy == 'continue' ||
                                currentVariant.inventory_management == 'null'
                            ) {
                                invalid = 'invalid'
                            }

                            outputHTML += `<p class="js-availability-notice quickview-availability disabled ${invalid} ">There are only <strong class="js-availablilty">${currentVariant.inventory}</strong> ${data.title} `

                            if (data.variants.length > 1) {
                                outputHTML +=
                                    '(<span class="js-varient">' + '</span>)'
                            }
                            outputHTML += ' available in stock.</p>'
                        }

                        el.innerHTML = outputHTML

                        break

                    case 'action':
                        if (data.available) {
                            outputHTML +=
                                '<button class="btn btn-primary" type="submit" name="add" id="qv-add-to-cart">'
                            outputHTML += inventory_text.add_to_cart
                            outputHTML += '</button>'
                        } else {
                            outputHTML +=
                                '<button class="btn btn-primary" disabled name="add" type="submit">' +
                                inventory_text.sold_out +
                                '</button>'
                        }
                        el.innerHTML = outputHTML

                        break

                    case 'images':
                        if (data.images) {
                            outputHTML +=
                                '<div class="swiper-container swiper initializing" data-slidestoshow="1" id="product-slider-qv">'
                            outputHTML += '<div class="swiper-wrapper">'

                            data.images.forEach((img, index) => {
                                let thisVariantID = ''

                                data.variants.forEach((variant, vIndex) => {
                                    if (
                                        variant.featured_image &&
                                        variant.featured_image.src == img
                                    ) {
                                        thisVariantID = variant.id
                                    }
                                })

                                outputHTML +=
                                    '<div class="swiper-slide" data-variant-id="' +
                                    thisVariantID +
                                    '">'
                                outputHTML += '<img src="' + img + '"/>'
                                outputHTML += '</div>'
                            })

                            outputHTML += '</div>'

                            outputHTML += '</div>'

                            outputHTML +=
                                '<div class="swiper-container swiper control initializing"  id="product-slider-nav-qv">'
                            outputHTML += '<div class="swiper-wrapper">'
                            data.images.forEach((img, index) => {
                                outputHTML += '<div class="swiper-slide">'
                                outputHTML += '<img src="' + img + '"/>'
                                outputHTML += '</div>'
                            })
                            outputHTML += '</div>'
                            outputHTML += '</div>'

                            outputHTML +=
                                '<div class="swiper-nav initializing">'
                            outputHTML +=
                                '<div class="swiper-button-prev swiper-prev"></div>'
                            outputHTML +=
                                '<div class="swiper-button-next swiper-next"></div>'
                            outputHTML += '</div>'
                        }

                        el.innerHTML = outputHTML

                        let sliderContainer =
                            quickViewModal.querySelector('#product-slider-qv')
                        let sliderControlContainer =
                            quickViewModal.querySelector(
                                '#product-slider-nav-qv'
                            )
                        let sliderNav =
                            quickViewModal.querySelector('.swiper-nav')

                        if (sliderContainer) {
                            window.initSlider(sliderContainer, 0, '.modal')

                            // 400ms is the transition time of the initial load
                            setTimeout(function () {
                                sliderContainer.classList.remove('initializing')
                                sliderNav.classList.remove('initializing')
                                sliderControlContainer.classList.remove(
                                    'initializing'
                                )
                            }, 400)
                        }

                        break
                }
            })

            if (data.variants.length > 1) {
                initProductScript(data, 'product-selectors-qv', quickViewModal)
            }

            quickViewModal.classList.remove('loading')
        }

        function _emptyQVModal() {
            allQVItems.forEach(function (el) {
                el.innerHTML = ''
            })

            quickViewModal.classList.add('loading')
        }
    }

    window.addEventListener('load', initQvModal)
})()
